// extracted by mini-css-extract-plugin
module.exports = {"legal":"legal_legal__mea1B","footer":"legal_footer__Elk6A"};